<template>
  <v-form lazy-validation @submit.prevent="onSubmit">
    <div class="recovery-header">
      <p class="recovery-description">
        Esqueceu ou não sabe sua senha? Não se preocupe! Digite seu e-mail
        cadastrado abaixo e enviaremos um código de recuperação para que você
        possa criar uma nova.
      </p>
    </div>
    <v-card-text>
      <v-text-field
        label="E-mail cadastrado"
        name="login"
        placeholder="Digite seu e-mail..."
        type="email"
        v-model="payload.email"
        :rules="emailRules"
        background-color="white"
        hide-details="auto"
        persistent-placeholder
        required
      ></v-text-field>
      <v-row class="mt-3">
        <v-col>
          <div class="text-center text">
            <v-btn
              color="primary"
              type="submit"
              :disabled="!isEmailValid"
              class="recovery-btn"
            >
              Enviar código de recuperação
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import { userAPI } from "@/modules/user";

export default {
  data() {
    return {
      payload: {},
      logo: this.$store.state.logo,
      emailRules: [
        (v) => !!v || "E-mail é obrigatório",
        (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido",
      ],
    };
  },
  computed: {
    isEmailValid() {
      const email = this.payload.email;
      return email && /.+@.+\..+/.test(email);
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onSubmit() {
      if (!this.isEmailValid) {
        this.$notification.error("Digite um e-mail válido", { timer: 5 });
        return;
      }

      this.setLoading(true);
      userAPI
        .recuperarSenha(this.payload)
        .then((resp) => {
          this.setLoading(false);
          // Emitir evento para mostrar tela de verificação de código
          this.$emit("codigo-enviado", this.payload.email);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao recuperar senha!", { timer: 10 });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 770px) {
  .text {
    button {
      font-size: 12px;
    }
  }
}
.recovery-header {
  text-align: center;
  margin-bottom: 24px;
}

.recovery-title {
  color: #2a4fd7;
  font-weight: 700;
  margin-bottom: 12px;
}

.recovery-description {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  padding: 0 16px;
}

.recovery-btn {
  font-weight: 600;
  padding: 12px 32px;
  border-radius: 8px;

  &:disabled {
    background-color: #e5e7eb !important;
    color: #9ca3af !important;
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>
